import React from 'react';
import { Text, StyleSheet } from 'react-native';
import { useLinkedAccountsColors } from '@/constants/residents/mobile/linkedAccountsColors';
import { newInvitationStrings } from '@/constants/residents/strings';
import { UnifiedModal } from '@/components/common/UnifiedModal';

interface InfoBubbleModalProps {
  visible: boolean;
  onClose: () => void;
}

export const InfoBubbleModal: React.FC<InfoBubbleModalProps> = ({
  visible,
  onClose,
}) => {
  const LAC = useLinkedAccountsColors();

  return (
    <UnifiedModal
      visible={visible}
      onClose={onClose}
      variant="sheet"
      title={newInvitationStrings.howItWorks.item2.title}
      showHeader
    >
      <Text style={[styles.descriptionText, { color: LAC.textSecondary }]}>
        {newInvitationStrings.howItWorks.item2.detail}
      </Text>
    </UnifiedModal>
  );
};

const styles = StyleSheet.create({
  descriptionText: {
    fontSize: 14,
    fontWeight: '400',
    lineHeight: 21,
    paddingHorizontal: 24,
    paddingBottom: 8,
  },
});
